import { kea } from "kea";

import api from '../utils/api';

import { rmovementlogic, rstationarylogic } from "./report";

export const triplogic = kea({
	actions: {
		update: (trip) => ({ trip }),

		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		loading: [false, {
			update: () => true,

			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		update: async ({ trip }, breakpoint) => {
			let url = `/trip/${trip._id}`;
			let res;
			try {
				res = await api({ url, method: 'put', body: trip });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			breakpoint();
			const json = await res.json();
			if (res.ok) {
				rmovementlogic.actions.setOne(json.payload);
				rstationarylogic.actions.setOne(json.payload);
				actions.setSuccess('Trip Updated.');
			} else actions.setError(json.error);
		}
	})
});

export default triplogic;